const ALNUM = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

export default () => {
  const bytes = window.crypto?.getRandomValues
    ? window.crypto.getRandomValues(new Uint8Array(32))
    : Array.from({ length: 32 }, () => Math.floor(Math.random() * 256));
  return Array.from(bytes, b => ALNUM[b % ALNUM.length]).join('');
};
